import React from "react";

import { Redirect } from "react-router-dom";

import ROUTES from "manager/config/routes";
import { useCosignDashboardAccess } from "manager/hooks/api";
import Container from "shared/components/Container";
import Skeleton from "shared/components/Skeleton";
import { BackLinkProps } from "shared/interfaces/misc";

import CosignDashboardContainer from "./CosignDashboardContainer";

interface CosignDashboardGateProps {
  backLink?: BackLinkProps;
}

/**
 * Guards the property-mapping dashboard (PRODUCT-988).
 * Requires Integrations Admin and an activated Cosign integration before rendering
 * the dashboard or calling property-mappings APIs.
 */
const CosignDashboardGate: React.FC<CosignDashboardGateProps> = ({
  backLink,
}) => {
  const { canAccessCosignDashboard, isCosignDashboardAccessLoading } =
    useCosignDashboardAccess();

  if (isCosignDashboardAccessLoading) {
    return (
      <Container>
        <Skeleton loading>
          <span />
        </Skeleton>
      </Container>
    );
  }

  if (!canAccessCosignDashboard) {
    return <Redirect to={ROUTES.cosignLogin} />;
  }

  return <CosignDashboardContainer backLink={backLink} />;
};

export default CosignDashboardGate;
